export default __webpack_public_path__ + "static/media/q25_02.1e758a04.png";